import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useLayoutEffect,
  Suspense
} from "react";

import { useDispatch, useSelector, connect } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Modal as AntModal } from "antd";
import { isMobile } from "react-device-detect";
import OptionActionTable from "../option-chain-table";
import {
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
  isProPlan
} from "../../../util/helper";
import Resizable from "react-resizable-layout";
import SampleSeparator from "../SampleSeparator";
import SampleBox from "../SampleBox";
import Position from "../positionPage";
import Basketindex from "../basket/index";
// import Straddle from "../straddle";
// import Strangle from "../strangle";
// import OptionActionFut from "../futures";
import Centrifuge from "centrifuge";

import HeaderDropdown, { initial as initialHeaderData } from "./headerDropdown";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useResizable } from 'react-resizable-layout';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { placeOrdersAction, basketAction, getMarginAction, getFundsAction } from "../../../redux/actions/brokerAction";
import { getZoomPrc, generateUniqueId, findStrikeDistanceStrangle, calculateSLTP, calculatePrice, findNearestValue, clearStrikeColor, changeColorToDiv, findStrikeDistance, clearColor } from "../../../util/helper";
import { Panel, PanelGroup, PanelResizeHandle, getPanelElement } from "react-resizable-panels";
import usePanelHeight from "../positionPage/position-comp/usePanelHeight";
// import ReadyMade from "../ready-made"
import QuikKeys from "../basket/advance/quikKeys"
import AlertMessage from "../../common/AlertMessage";
import { message } from "../../../config"
import ChooseBasketModal from "../option-chain-table/ChooseBasketModal";
import OrderWindowModal from "./OrderWindowModal";

import {
  getTicksData,
} from "../../../redux/actions/optionChain";
import SubscriptionCheckModal from "components/common/SubscriptionCheckModal";
import TerminalInfoModal from "./TerminalInfoModal";
import LoderCom from "components/common/Loder";
import { useToast } from "components/common/custom-toast/Toast";

const OptionActionFut = React.lazy(() => import("../futures"));
const Strangle = React.lazy(() => import("../strangle"));
const ReadyMade = React.lazy(() => import("../ready-made"));
const defX = {
  axis: "x",
  initial: 400,
  min: 350,
  max: 450,
};

const defY = {
  axis: "y",
  initial: 600,
  min: 200,
  max: 1000,

};


const DefColumns = [
  {
    header: 'Delta',
    accessorKey: 'deltaCE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'IV',
    accessorKey: 'ivCE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'OI chg',
    accessorKey: 'oiChgCE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'OI',
    accessorKey: 'oiCE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'LTP',
    accessorKey: 'lpCE',
    enableColumn: true,
    align: "center",
    width: 20,
    isDecimal: false

  },

  {
    header: 'Strike',
    accessorKey: 'strike',
    enableColumn: true,
    align: "center",
    width: 20,
    isDecimal: false

  },

  {
    header: 'LTP',
    accessorKey: 'lpPE',
    enableColumn: true,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'OI',
    accessorKey: 'oiPE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'OI chg',
    accessorKey: 'oiChgPE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  },
  {
    header: 'Delta',
    accessorKey: 'deltaPE',
    enableColumn: false,
    align: "center",
    width: 20,
    isDecimal: false

  }
];

const isObject = (value) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

const normalizeStrangleData = (data) => {
  const normalized = {};

  Object.entries(data).forEach(([idx, row]) => {
    const strikeCE = row.strikeCE;
    const strikePE = row.strikePE;
    if (strikeCE && ('ceLP' in row)) {
      const strikeKeyCE = String(strikeCE);

      if (!(strikeKeyCE in normalized)) {
        normalized[strikeKeyCE] = {
          strike: strikeCE,
          symbolsToStrikePrice: {}
        };
      }

      const ceData = {
        lpCE: row.ceLP || row.lpce,
        chgCE: row.ceChg || row.chgce,
        pChgCE: row.cePChg || row.pChgce,
        ivCE: row.ceiv || row.ivce,
        ivChgCE: row.ivChgce,
        oiCE: row.oice,
        oiChgCE: row.oiChgce,
        oiPChgCE: row.oiPChgce,
        volCE: row.volce,
        buildupCE: row.buildupce,
        trendCE: row.trendce,
        orderflowCE: row.orderflowce,
        deltaCE: row.deltace,
        gammaCE: row.gammace,
        thetaCE: row.thetace,
        vegaCE: row.vegace,
        bidCE: row.bidce,
        askCE: row.askce,
        atpCE: row.atpce,
        ltpChgOpenCE: row.ltpChgOpence || row.ceChg_open,
        ltpChgPOpenCE: row.ltpChgPOpence || row.cePChg_open
      };

      Object.keys(ceData).forEach(key => {
        if (ceData[key] !== undefined && ceData[key] !== null) {
          normalized[strikeKeyCE][key] = ceData[key];
        }
      });
      if (row.CE) {
        normalized[strikeKeyCE].symbolsToStrikePrice = {
          // ...normalized[strikeKeyCE].symbolsToStrikePrice,
          CE: row.CE,
          'exchangeToken-CE': row['exchangeToken-CE'],
          'tradingSymbol-CE': row['tradingSymbol-CE'],
          'exchange-CE': row['exchange-CE'],
          'lotSize-CE': row['lotSize-CE'],
          'displayName-CE': row['displayName-CE'],
          'strike-CE': strikeCE
        };
      }
    }

    if (strikePE && ('peLP' in row)) {
      const strikeKeyPE = String(strikePE);

      if (!(strikeKeyPE in normalized)) {
        normalized[strikeKeyPE] = {
          strike: strikePE,
          symbolsToStrikePrice: {}
        };
      }

      const peData = {
        lpPE: row.peLP || row.lppe,
        chgPE: row.peChg || row.chgpe,
        pChgPE: row.pePChg || row.pChgpe,
        ivPE: row.peiv || row.ivpe,
        ivChgPE: row.ivChgpe,
        oiPE: row.oipe,
        oiChgPE: row.oiChgpe,
        oiPChgPE: row.oiPChgpe,
        volPE: row.volpe,
        buildupPE: row.builduppe,
        trendPE: row.trendpe,
        orderflowPE: row.orderflowpe,
        deltaPE: row.deltape,
        gammaPE: row.gammape,
        thetaPE: row.thetape,
        vegaPE: row.vegape,
        bidPE: row.bidpe,
        askPE: row.askpe,
        atpPE: row.atppe,
        ltpChgOpenPE: row.ltpChgOpenpe || row.peChg_open,
        ltpChgPOpenPE: row.ltpChgPOpenpe || row.pePChg_open
      };

      Object.keys(peData).forEach(key => {
        if (peData[key] !== undefined && peData[key] !== null) {
          normalized[strikeKeyPE][key] = peData[key];
        }
      });

      if (row.PE) {
        normalized[strikeKeyPE].symbolsToStrikePrice = {
          ...normalized[strikeKeyPE].symbolsToStrikePrice,
          PE: row.PE,
          'exchangeToken-PE': row['exchangeToken-PE'],
          'tradingSymbol-PE': row['tradingSymbol-PE'],
          'exchange-PE': row['exchange-PE'],
          'lotSize-PE': row['lotSize-PE'],
          'displayName-PE': row['displayName-PE'],
          'strike-PE': strikePE
        };
      }
    }
  });

  Object.keys(normalized).forEach(strikeKey => {
    if (normalized[strikeKey].oiCE && normalized[strikeKey].oiPE) {
      const oiCe = normalized[strikeKey].oiCE;
      const oiPe = normalized[strikeKey].oiPE;
      if (oiCe !== 0) {
        normalized[strikeKey].pcrCE = oiPe / oiCe;
        normalized[strikeKey].pcrPE = oiPe / oiCe;
      }
    }
  });

  return normalized;
};


const detectAndNormalizeStrikeData = (data) => {
  if (!data || !isObject(data)) {
    return data;
  }

  const keys = Object.keys(data);
  if (keys.length === 0) {
    return data;
  }

  const firstKey = keys[0];
  const firstValue = data[firstKey];

  let isdata = false;

  if ('strikeCE' in firstValue || 'strikePE' in firstValue) {
    isdata = true;
  } else if ('symbolsToStrikePrice' in firstValue) {
    isdata = false;
  } else {
    if (keys.every(k => /^\d+$/.test(k) && parseInt(k) < 100)) {
      isdata = true;
    }
  }

  if (!isdata) {
    return data;
  }

  return normalizeStrangleData(data);
};

let localStorageObj = getLocalStorageObject("columnSettingsOp") || {
  opColumns: []
}
const maxSizeV = 94;
const minSizeV = 6;

const defaultSize = 50;
const Dashboard = () => {
  const panelRef = useRef(null);
  const dashPage = useRef(null);
  const toast = useToast()

  const basket = useSelector((state) => state.basket.data);
  const postionList = useSelector((state) => state?.orders?.positions);

  const rawStrikeData = useSelector((state) => state?.optionChaininstruments?.strikeData);
  const strikeData = React.useMemo(() => {
    return detectAndNormalizeStrikeData(rawStrikeData);
  }, [rawStrikeData]);
  const middleStrike = useSelector((state) => state?.optionChaininstruments?.middleStrike);
  const isLoggedIn = useSelector((s) => s?.user?.isLoggedIn === true);
  const brokersList = useSelector((state) => state?.brokers?.list || []);
  const brokerLoggedIn = useSelector((s) => s?.user?.brokerLoggedIn === true);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const accessiblePlans = useSelector((state) => state?.packages?.accessiblePlans);
  const plansLoading = accessiblePlans === undefined;
  const hasManualAccess = accessiblePlans?.length > 0 ? accessiblePlans?.some(planName =>
    planName === 'QT-Unlimited' || planName === 'QT-Manual' || planName === "trial"
  ) : false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chartWrap = useRef();
  const strikeRef = useRef({});
  const chartFilterWrap = useRef();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [posHeight, setPosHeight] = useState();
  const [posWidth, setPosWidth] = useState();
  const [optHeight, setoptHeight] = useState();
  const [optWidth, setoptWidth] = useState();
  const [defYh, setdefYh] = useState({});
  const [defXH, setdefX] = useState(defX);
  const [lotSize, setlotSize] = useState(0);
  const [volumeFreeze, setvolumeFreeze] = useState(0);
  const [scrollSize, setscrollSize] = useState(25);
  const [strikeCE, setstrikeCE] = useState("");
  const [strikePE, setstrikePE] = useState("");

  const [inputValues, setinputValues] = useState(initialHeaderData || {});
  const [atmPrice, setatmPrice] = useState(0);
  const windowScreen = useSelector((state) => state.windowScreen);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isQT, setisQT] = useState(getLocalStorageObject("global")?.isQT || false);
  const [atmVal, setatmVal] = useState(getLocalStorageObject("global")?.atm || 'Spot');
  const [hedge, sethedge] = useState(getLocalStorageObject("global")?.hedge || 'Premium');
  const [DropDonwcolumns, setColumns] = useState(() => {
    const saved = getLocalStorageObject("columnSettingsOp")?.opColumns;
    if (saved && saved.length > 0) {
      let merged = saved.filter(m => m.accessorKey !== 'synFut');
      DefColumns.forEach(defCol => {
        if (!merged.find(m => m.accessorKey === defCol.accessorKey)) {
          merged.push(defCol);
        }
      });
      return merged;
    }
    return DefColumns;
  });
  const [hedgeVal, sethedgeVal] = useState(0);
  const [dragging, setdragging] = useState(false);
  const [sockSource, setSockSource] = useState(false);
  const [hedgeOrders, sethedgeOrders] = useState({});
  const [opActiveTab, setopActiveTab] = useState(0);
  const [isSellFirst, setisSellFirst] = useState(getLocalStorageObject("global")?.isSellFirst || false);
  const [warpHeight, setWarpHeight] = useState(0);
  const [basketTabs, setbasketTabs] = useState(1);
  const [clickDiv, setclickDiv] = useState("");

  const [isBlink, setisBlink] = useState(false);

  const [posMinSize, setPosMinSize] = useState(10);
  const [orderMinMaxSize, setorderMinMaxSize] = useState({
    min: 5,
    max: 95
  });

  const info = useSelector((state) => state.filter);

  const [slicingInfo, setSlicingInfo] = useState({
    show: false,
    totalOrders: 0,
    maxQty: 0,
    maxLot: 0,
    totalOrderQty: 0,
    totalOrderLot: 0,
    args: []
  });

  const [showInfoModal, setShowInfoModal] = useState(localStorage.getItem('hideTerminalInfoModal') !== 'true');

  const handleInfoModalClose = useCallback(() => {
    setShowInfoModal(false);
  }, []);

  const [orderWindowModal, setOrderWindowModal] = useState({
    show: false,
    orderData: null,
    originalArgs: []
  });

  useEffect(() => {

    document.addEventListener("click", function (event) {
      setclickDiv(event.target.name);
    });
  }, []);

  // connecting to socket data
  useEffect(() => {
    const centrifuge = new Centrifuge(
      process.env.REACT_APP_API_FEED
    );

    centrifuge.on("connect", function (ctx) {
      console.log(
        "Connected with client ID " + ctx.client + " over " + ctx.transport
      );
    });

    centrifuge.on("disconnect", function (ctx) {
      console.log(
        "Disconnected: " +
        ctx.reason +
        (ctx.reconnect
          ? ", will try to reconnect"
          : ", won't try to reconnect")
      );
    });

    centrifuge.connect();
    setSockSource(centrifuge);

    // setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
  }, []);

  useEffect(() => {
    clearStrikeColor('lp', 'ce');
    clearStrikeColor('lp', 'pe');
    clearStrikeColor('delta', 'ce');
    clearStrikeColor('delta', 'pe');

    if (hedge && hedgeVal && strikeData && Object.keys(strikeData).length > 0 && middleStrike) {

      if (hedgeOrders && Object.keys(hedgeOrders).length > 0) {
        clearColor(hedgeOrders?.ce?.strike + '-lpCE', hedgeOrders?.pe?.strike + '-lpPE')
        clearColor(hedgeOrders?.ce?.strike + '-deltaCE', hedgeOrders?.pe?.strike + '-deltaPE')
        clearColor(hedgeOrders?.ce?.strike + '-strike', hedgeOrders?.pe?.strike + '-strike')
      }
      if (hedge === "Premium") {
        sethedgeOrders(findNearestValue(strikeData, hedgeVal, 'lp', opActiveTab));
      } else if (hedge === "Distance") {
        sethedgeOrders(findStrikeDistance(strikeData, hedgeVal, middleStrike, 'both', false));
        strikeRef.current = findStrikeDistance(strikeData, hedgeVal, middleStrike, "both", false) || {};
      } else {

        sethedgeOrders(findNearestValue(strikeData, hedgeVal, 'delta', opActiveTab));
      }
    } else {
      if (hedgeOrders && Object.keys(hedgeOrders).length > 0) {
        clearColor(hedgeOrders?.ce?.strike + '-lpCE', hedgeOrders?.pe?.strike + '-lpPE')
        clearColor(hedgeOrders?.ce?.strike + '-deltaCE', hedgeOrders?.pe?.strike + '-deltaPE')
        clearColor(hedgeOrders?.ce?.strike + '-strike', hedgeOrders?.pe?.strike + '-strike')
      }
      sethedgeOrders({})
    }
  }, [hedge, strikeData, hedgeVal, middleStrike]);

  useEffect(() => {

    if (basket.length === 0) {
      return;
    }
    setisBlink(true);
    setTimeout(() => {
      setisBlink(false);
    }, 3000)
  }, [basket]);


  const rowHover = (selltype, type, rowData, isStraddle, page, enterOrleave) => {
    if (enterOrleave === "e") {
      if (hedgeOrders && Object.keys(hedgeOrders).length > 0) {
        var BGcolor = "#00d27a80"
        if (selltype === "B") {
          BGcolor = "#ef5350b3";
        } else {
          BGcolor = "#00d27a80";
        }

        const buyColor = "#ef5350b3";
        const sellColor = "#00d27a80";
        const ceBG = (page === 'synFut') ? (selltype === 'B' ? buyColor : sellColor) : BGcolor;
        const peBG = (page === 'synFut') ? (selltype === 'B' ? sellColor : buyColor) : BGcolor;

        if (!isStraddle) {
          if (hedge === "Premium") {
            changeColorToDiv(hedgeOrders[type].strike + ['-lp' + type.toUpperCase()], type === 'ce' ? ceBG : peBG)
          } else if (hedge === "Distance") {

            if (strikeRef.current && Object.keys(strikeRef.current).length > 0) {
              clearStrikeColor('lp', type);
              var strce = "";
              if (page === "st") {
                strce = type == "ce" ? rowData.strikeCE : rowData.strikePE;

              } else {
                strce = rowData.strike;
              }

              if (findStrikeDistance(strikeData, hedgeVal, strce, type, isStraddle)) {
                strikeRef.current = findStrikeDistance(strikeData, hedgeVal, strce, type, isStraddle);
                if (strikeRef.current && strikeRef.current[type]) {
                  changeColorToDiv(strikeRef.current[type].strike + ['-lp' + type.toUpperCase()], type === 'ce' ? ceBG : peBG)
                }
              }
            }
          } else {
            changeColorToDiv(hedgeOrders[type].strike + ['-delta' + type.toUpperCase()], type === 'ce' ? ceBG : peBG)

          }

        } else {

          if (hedge === "Premium") {

            changeColorToDiv(hedgeOrders["ce"].strike + ['-lpCE'], ceBG)
            changeColorToDiv(hedgeOrders["pe"].strike + ['-lpPE'], peBG)
          } else if (hedge === "Distance") {
            if (strikeRef.current && Object.keys(strikeRef.current).length > 0) {
              clearStrikeColor('lp', "ce");
              clearStrikeColor('lp', "pe");
              var strpe = "";
              if (page === "st") {
                strpe = type == "ce" ? rowData.strikeCE : rowData.strikePE;

              } else {
                strpe = rowData.strike;
              }

              if (page === "st") {
                strikeRef.current = findStrikeDistanceStrangle(strikeData, hedgeVal, rowData.strikeCE, rowData.strikePE)
                if (strikeRef.current) {
                  if (strikeRef.current["ce"]) {
                    changeColorToDiv(strikeRef.current["ce"].strike + ['-lpCE'], ceBG)
                  }

                  if (strikeRef.current["pe"]) {
                    changeColorToDiv(strikeRef.current["pe"].strike + ['-lpPE'], peBG)
                  }
                }
              } else {
                if (findStrikeDistance(strikeData, hedgeVal, strpe, type, isStraddle)) {
                  strikeRef.current = findStrikeDistance(strikeData, hedgeVal, strpe, type, isStraddle);
                  if (strikeRef.current) {
                    if (strikeRef.current["ce"]) {
                      changeColorToDiv(strikeRef.current["ce"].strike + ['-lpCE'], ceBG)
                    }

                    if (strikeRef.current["pe"]) {
                      changeColorToDiv(strikeRef.current["pe"].strike + ['-lpPE'], peBG)
                    }
                  }
                }
              }


            }
          } else {
            changeColorToDiv(hedgeOrders["ce"].strike + ['-deltaCE'], ceBG)
            changeColorToDiv(hedgeOrders["pe"].strike + ['-deltaPE'], peBG)

          }
        }
      }
    } else {
      clearStrikeColor('lp', "ce");
      clearStrikeColor('lp', "pe");
      clearStrikeColor('delta', "ce");
      clearStrikeColor('delta', "pe");
    }
  }

  const isBrokersLoading = useSelector((state) => state?.brokers?.isLoading);
  const isPlansLoading = useSelector((state) => state?.packages?.isLoading);

  useEffect(() => {
    if (isBrokersLoading || isPlansLoading) {
      return;
    }

    if (!isLoggedIn) {
      toast.error("Please login to access Terminal");
      navigate("/authentication/login");
      return;
    }

    if (hasManualAccess === false) {
      setShowSubscriptionModal(true);
      return;
    }

    if (!brokerLoggedIn) {
      toast.error("Please connect your broker account to access Terminal");
      navigate("/broker-login");
      return;
    }

    const purposed = (brokersList || []).filter(b => (b.purpose === 'terminal' || b.type === 'papertrading'));
    if (purposed.length === 0) {
      toast.error("Please use broker account with purpose 'terminal' to access Terminal");
      navigate("/broker-login");
      return;
    }

  }, [isLoggedIn, brokerLoggedIn, hasManualAccess, isPlansLoading, isBrokersLoading, brokersList]);

  useEffect(() => {

    if (windowScreen.rightBottomWindow) {
      collapsePanel(windowScreen.rightBottomWindow.updown)
    }
  }, [windowScreen]);

  const calculateResponsiveMinSize = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const aspectRatio = screenWidth / screenHeight;


    let baseSize;

    if (screenHeight >= 2160) {
      baseSize = 4;
    } else if (screenHeight >= 1440) {
      baseSize = 6;
    } else if (screenHeight >= 1080) {
      baseSize = 10;
    } else if (screenHeight >= 768) {
      baseSize = 14;
    } else {
      baseSize = 20;
    }

    if (aspectRatio > 2.0) {
      baseSize *= 0.8;
    } else if (aspectRatio > 1.8) {
      baseSize *= 0.9;
    }

    return Math.round(baseSize);
  };
  const collapsePanel = (updown) => {
    const panel = panelRef.current;
    if (panel && windowScreen?.rightBottomWindow?.fullScreen) {
      panel?.resize(100);
    }
    if (panel && !windowScreen?.rightBottomWindow?.fullScreen) {
      if (updown) {
        const minSize = calculateResponsiveMinSize();
        panel?.resize(minSize);
      } else {
        panel?.resize(defaultSize);
      }
    }
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      const panelElement = getPanelElement("basket-pannel");
      const panelPosElement = getPanelElement("postition-pannel");
      const panelOPTElement = getPanelElement("opt-id");
      var baskobserver, posobserver, otpobserver;
      if (panelElement) {

        const observer = new ResizeObserver(() => {
          setHeight(panelElement.offsetHeight);
          setWidth(panelElement.offsetWidth);
        });

        baskobserver = observer.observe(panelElement);

        // return () => observer.disconnect();
      }


      if (panelPosElement) {
        const observer = new ResizeObserver(() => {
          window.innerWidth < 768 ? setPosWidth("unset") : setPosWidth(panelPosElement.offsetWidth);
          setPosHeight(panelPosElement.offsetHeight);
        });

        posobserver = observer.observe(panelPosElement);


      }
      if (panelOPTElement) {
        const observer = new ResizeObserver(() => {
          setoptHeight(panelOPTElement.offsetHeight);
          setoptWidth(panelOPTElement.offsetWidth);
        });

        otpobserver = observer.observe(panelOPTElement);

      }
      return () => {
        try {
          baskobserver.disconnect();
          posobserver.disconnect()
          otpobserver.disconnect()

        } catch (e) {

        }
      }
    }, 0);


  }, [dragging, windowScreen]);




  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      getWrapSize();
    });

    if (chartFilterWrap.current) {
      resizeObserver.observe(chartFilterWrap.current);
    }

    window.addEventListener('resize', getWrapSize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', getWrapSize);
    };
  }, []);

  useEffect(() => {
    async function getFunds() {
      await dispatch(getFundsAction(info?.broker?.id));
    }
    if (info?.broker?.id) {
      getFunds();
    }
  }, [info]);

  const getWrapSize = () => {
    if (chartFilterWrap?.current) {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      if (viewportWidth < 768) {
        setWarpHeight("100vh");
        return;
      }

      const newWidth = chartWrap.current ? chartWrap.current.clientWidth : 0;
      const newChartFilterWrapHeight = chartFilterWrap?.current?.clientHeight;
      const headerOffset = newChartFilterWrapHeight + 50;

      const newHeight = viewportHeight - headerOffset;

      setWarpHeight(Math.max(newHeight, 400));
    }
  }
  const getlotSize = (lotSize, volumeFreeze) => {
    // setlotSize(lotSize);
    // setvolumeFreeze(volumeFreeze);
  };

  const getformValue = (lotSize) => {
    setlotSize(lotSize);
  };

  const getInputValues = (val, type) => {
    setinputValues(val);
  };

  const getATMprice = (price) => {
    setatmPrice(price);
  };


  const refresh = () => {
    setIsRefresh(true);
    setTimeout(() => {
      setIsRefresh(false);
    }, 3000)
  }



  const [chooseBasketState, setChooseBasketState] = useState({ show: false, existingBaskets: [], defaultNewName: "", proceed: null });

  const processBuySell = async (type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket) => {

    if (isQT && isBoth === true && (page === "straddle" || page === "strangle" || page === "custom" || page === "synFut")) {
      const modalGrouping = getLocalStorageObject("global-bottom-other") ? getLocalStorageObject("global-bottom-other").strategygrouping : true;
      if (modalGrouping) {
        const targetExchangeTokens = [];
        if (tokens?.["exchangeToken-CE"]) targetExchangeTokens.push(tokens["exchangeToken-CE"]);
        if (tokens?.["exchangeToken-PE"]) targetExchangeTokens.push(tokens["exchangeToken-PE"]);

        const existingNames = Array.from(new Set(
          (postionList || [])
            .filter(it => targetExchangeTokens.includes(it?.instrument?.exchangeToken))
            .map(it => it?.basketName || "")
            .filter(name => name && name.trim().length > 0)
        ));
        if (existingNames.length > 0 && (!chosenBasket || typeof chosenBasket !== 'object')) {
          let suggested = "";
          if (page === "straddle") suggested = `STRADDLE-${strike}`;
          else if (page === "strangle" || page === "custom") suggested = `STRANGLE-${value?.data?.strikeCE}C-${value?.data?.strikePE}P`;
          else if (page === "synFut") suggested = (type === "BUY" ? "LONG-" : "SHORT-") + "SYNFUT-" + strike;
          else suggested = tokens?.[`displayName-${cellType}`] || "";
          const existingBasketObjs = Array.from(new Map(
            (postionList || [])
              .filter(it => targetExchangeTokens.includes(it?.instrument?.exchangeToken))
              .map(it => [it.basketId || "", { id: it.basketId || "", name: it.basketName || "" }])
          ).values()).filter(b => b.id && b.name);

          setChooseBasketState({
            show: true,
            existingBaskets: existingBasketObjs,
            defaultNewName: suggested,
            proceed: (selection) => processBuySell(type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, selection)
          });
          return;
        }
      }
    }

    if (isQT && page === "singleLeg" && (!chosenBasket || typeof chosenBasket !== 'object')) {
      const modalGrouping = getLocalStorageObject("global-bottom-other") ? getLocalStorageObject("global-bottom-other").strategygrouping : true;
      if (modalGrouping) {
        const targetExchangeTokens = [];
        if (tokens?.["exchangeToken-" + cellType]) targetExchangeTokens.push(tokens["exchangeToken-" + cellType]);

        const positions = (postionList || []);

        const basketCount = positions.reduce((acc, p) => {
          const id = p?.basketId || "";
          const name = (p?.basketName || "").trim();
          if (id && name) acc[id] = (acc[id] || 0) + 1;
          return acc;
        }, {});
        const multiLegBasketIds = new Set(Object.keys(basketCount).filter(id => basketCount[id] > 1));

        const existingBasketObjs = Array.from(new Map(
          positions
            .filter(it => multiLegBasketIds.has(it?.basketId || ""))
            .filter(it => targetExchangeTokens.includes(it?.instrument?.exchangeToken))
            .map(it => [it.basketId || "", { id: it.basketId || "", name: it.basketName || "" }])
        ).values()).filter(b => b.id && b.name);

        if (existingBasketObjs.length > 0) {
          const suggested = `${cellType}-${strike}`;
          setChooseBasketState({
            show: true,
            existingBaskets: existingBasketObjs,
            defaultNewName: suggested,
            proceed: (selection) => processBuySell(type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, selection)
          });
          return;
        }
      }
    }

    var deforder = [];
    var hOrders = {};

    const tickTokenSet = new Set();
    if (isBoth) {
      if (tokens?.CE) tickTokenSet.add(tokens.CE);
      if (tokens?.PE) tickTokenSet.add(tokens.PE);
    } else if (cellType && tokens?.[cellType]) {
      tickTokenSet.add(tokens[cellType]);
    }

    if (page != "position" && page != "risk" && page != "chart" && hedge && hedgeVal && strikeData && Object.keys(strikeData).length > 0 && middleStrike) {
      const h = (hedge === "Distance") ? (strikeRef.current || {}) : (hedgeOrders || {});
      if (isBoth) {
        if (h['ce']?.symbolsToStrikePrice?.CE) tickTokenSet.add(h['ce'].symbolsToStrikePrice['CE']);
        if (h['pe']?.symbolsToStrikePrice?.PE) tickTokenSet.add(h['pe'].symbolsToStrikePrice['PE']);
      } else if (cellType && h[cellType?.toLowerCase()]?.symbolsToStrikePrice?.[cellType]) {
        tickTokenSet.add(h[cellType.toLowerCase()].symbolsToStrikePrice[cellType]);
      }
    }

    if (inputValues.orderWindowLegs && inputValues.orderWindowLegs.length > 0) {
      inputValues.orderWindowLegs.forEach(leg => {
        if (leg.token) tickTokenSet.add(leg.token);
      });
    }

    const latestTicks = (tickTokenSet.size > 0 ? await getTicksData(Array.from(tickTokenSet)) : {});
    const data = latestTicks;
    const hdata = latestTicks;

    if (inputValues.orderWindowLegs && inputValues.orderWindowLegs.length > 0) {
      deforder = inputValues.orderWindowLegs.map(leg => {
        const sltp = calculateSLTP(
          inputValues.stopLossPrice,
          inputValues.targetPrice,
          leg.side,
          leg.triggerPrice,
          inputValues.riskCoverType
        );

        return {
          exchange: leg.exchange,
          variety: "REGULAR",
          validity: page === "position" ? "DAY" : inputValues.validity,
          product: leg.product,
          orderType: leg.orderType,
          transactionType: leg.side,
          quantity: leg.quantity * leg.lotSize,
          oldquantity: leg.quantity * leg.lotSize,
          price: leg.price,
          triggerPrice: leg.triggerPrice,
          exchangeToken: leg.exchangeToken,
          disclosedQuantity: 0,
          stopLossPrice: sltp?.stopLossPrice ? parseFloat(sltp.stopLossPrice) : null,
          targetPrice: sltp?.targetPrice ? parseFloat(sltp.targetPrice) : null,
          trailReferencePoints: null,
          trailStepPoints: null,
          cellType: leg.cellType,
          symbol: info.instrument,
          expiry: info.selectExpiry,
          strike: leg.strike,
          lotSize: leg.lotSize,
          instrumentToken: leg.token,
          isHedge: !!leg.isHedge,
          displayName: leg.displayName,
          marketProtect: leg.marketProtect,
          marketBuffer: leg.marketBuffer
        };
      });

      const { orderWindowLegs, ...restOfInputValues } = inputValues;
      setinputValues(restOfInputValues);

    } else {
      if (page != "position" && page != "risk" && page != "chart" && hedge && hedgeVal && strikeData && Object.keys(strikeData).length > 0 && middleStrike) {

        if (hedge === "Distance") {
          hOrders = strikeRef.current;
        } else {
          hOrders = hedgeOrders;
        }

        var txtType = type === "BUY" ? "SELL" : "BUY";

        const hTypeCE = txtType;
        const hTypePE = page === 'synFut' ? type : txtType;

        if (isBoth) {
          const hcalculatePricePE = calculatePrice(
            hdata[hOrders['pe']?.symbolsToStrikePrice['PE']]?.lp,
            inputValues.marketProtect,
            hTypePE,
            inputValues.orderType,
            inputValues.marketBuffer
          )

          const hcalculatePriceCE = calculatePrice(
            hdata[hOrders['ce']?.symbolsToStrikePrice['CE']]?.lp,
            inputValues.marketProtect,
            hTypeCE,
            inputValues.orderType,
            inputValues.marketBuffer
          )

          const hsltpCE = calculateSLTP(
            inputValues.stopLossPrice,
            inputValues.targetPrice,
            hTypeCE,
            hdata[hOrders['ce']?.symbolsToStrikePrice['CE']]?.lp,
            inputValues.riskCoverType
          );

          const sltpPE = calculateSLTP(
            inputValues.stopLossPrice,
            inputValues.targetPrice,
            hTypePE,
            hdata[hOrders['pe']?.symbolsToStrikePrice['PE']]?.lp,
            inputValues.riskCoverType
          );

          if (hOrders['ce']) {
            deforder.push({
              exchange: hOrders['ce'].symbolsToStrikePrice['exchange-CE'],
              variety: "REGULAR",
              validity: inputValues.validity,
              product: inputValues.product,
              orderType: inputValues.orderType,
              transactionType: hTypeCE,
              quantity: parseInt(inputValues.orderQty) * hOrders['ce'].symbolsToStrikePrice['lotSize-CE'],
              oldquantity: parseInt(inputValues.orderQty) * hOrders['ce'].symbolsToStrikePrice['lotSize-CE'],
              price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(hcalculatePriceCE?.price),
              exchangeToken: hOrders['ce'].symbolsToStrikePrice['exchangeToken-CE'],
              disclosedQuantity: 0,
              stopLossPrice: hsltpCE?.stopLossPrice ? parseFloat(hsltpCE?.stopLossPrice) : null,
              targetPrice: hsltpCE?.targetPrice ? parseFloat(hsltpCE?.targetPrice) : null,
              trailReferencePoints: null,
              trailStepPoints: null,
              cellType: "CE",
              symbol: info.instrument,
              expiry: info.selectExpiry,
              strike: hOrders['ce'].strike,
              lotSize: hOrders['ce'].symbolsToStrikePrice['lotSize-CE'],
              instrumentToken: hOrders['ce'].symbolsToStrikePrice['CE'],
              isHedge: true,
              marketProtect: inputValues.marketProtect,
              marketBuffer: inputValues.marketBuffer
            })
          }



          if (hOrders['pe']) {
            deforder.push({
              exchange: hOrders['pe'].symbolsToStrikePrice['exchange-PE'],
              variety: "REGULAR",
              validity: inputValues.validity,
              product: inputValues.product,
              orderType: inputValues.orderType,
              transactionType: hTypePE,
              quantity: parseInt(inputValues.orderQty) * hOrders['pe'].symbolsToStrikePrice['lotSize-PE'],
              oldquantity: parseInt(inputValues.orderQty) * hOrders['pe'].symbolsToStrikePrice['lotSize-PE'],
              price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(hcalculatePricePE?.price),
              exchangeToken: hOrders['pe'].symbolsToStrikePrice['exchangeToken-PE'],
              disclosedQuantity: 0,
              stopLossPrice: sltpPE?.stopLossPrice ? parseFloat(sltpPE?.stopLossPrice) : null,
              targetPrice: sltpPE?.targetPrice ? parseFloat(sltpPE?.targetPrice) : null,
              trailReferencePoints: null,
              trailStepPoints: null,
              cellType: "PE",
              symbol: info.instrument,
              expiry: info.selectExpiry,
              strike: hOrders['pe'].strike,
              lotSize: hOrders['pe'].symbolsToStrikePrice['lotSize-PE'],
              instrumentToken: hOrders['pe'].symbolsToStrikePrice['PE'],
              isHedge: true,
              marketProtect: inputValues.marketProtect,
              marketBuffer: inputValues.marketBuffer
            })
          }

        } else {

          if (hOrders[cellType.toLowerCase()]) {

            const hcalPrice = calculatePrice(
              hdata[hOrders[cellType.toLowerCase()]?.symbolsToStrikePrice[cellType]]?.lp,
              inputValues.marketProtect,
              txtType,
              inputValues.orderType,
              inputValues.marketBuffer
            )


            const hsltp = calculateSLTP(
              inputValues.stopLossPrice,
              inputValues.targetPrice,
              txtType,
              hdata[hOrders[cellType.toLowerCase()]?.symbolsToStrikePrice[cellType]]?.lp,
              inputValues.riskCoverType
            );


            deforder.push({
              exchange: hOrders[cellType.toLowerCase()]?.symbolsToStrikePrice['exchange-' + cellType],
              variety: "REGULAR",
              validity: inputValues.validity,
              product: inputValues.product,
              orderType: inputValues.orderType,
              transactionType: txtType,
              quantity: parseInt(inputValues.orderQty) * hOrders[cellType.toLowerCase()].symbolsToStrikePrice['lotSize-' + cellType],
              oldquantity: parseInt(inputValues.orderQty) * hOrders[cellType.toLowerCase()].symbolsToStrikePrice['lotSize-' + cellType],
              price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(hcalPrice.price),
              exchangeToken: hOrders[cellType.toLowerCase()].symbolsToStrikePrice['exchangeToken-' + cellType],
              disclosedQuantity: 0,
              stopLossPrice: hsltp?.stopLossPrice ? parseFloat(hsltp?.stopLossPrice) : null,
              targetPrice: hsltp?.targetPrice ? parseFloat(hsltp?.targetPrice) : null,
              trailReferencePoints: null,
              trailStepPoints: null,
              cellType: cellType,
              symbol: info.instrument,
              expiry: info.selectExpiry,
              strike: hOrders[cellType.toLowerCase()].strike,
              lotSize: hOrders[cellType.toLowerCase()].symbolsToStrikePrice['lotSize-' + cellType],
              instrumentToken: hOrders[cellType.toLowerCase()].symbolsToStrikePrice[cellType],
              isHedge: true,
              marketProtect: inputValues.marketProtect,
              marketBuffer: inputValues.marketBuffer
            })
          }
        }

      }


      if (tickTokenSet.size === 0) {
        return;
      }

      if (isBoth) {
        const typeCE = page === 'synFut' ? (type === 'BUY' ? 'BUY' : 'SELL') : type;
        const typePE = page === 'synFut' ? (type === 'BUY' ? 'SELL' : 'BUY') : type;

        const calculatePricePE = calculatePrice(
          data[tokens.PE]?.lp,
          inputValues.marketProtect,
          typePE,
          inputValues.orderType,
          inputValues.marketBuffer
        )

        const calculatePriceCE = calculatePrice(
          data[tokens.CE]?.lp,
          inputValues.marketProtect,
          typeCE,
          inputValues.orderType,
          inputValues.marketBuffer
        )

        const sltpCE = calculateSLTP(
          inputValues.stopLossPrice,
          inputValues.targetPrice,
          typeCE,
          data[tokens.CE]?.lp,
          inputValues.riskCoverType
        );

        const sltpPE = calculateSLTP(
          inputValues.stopLossPrice,
          inputValues.targetPrice,
          typePE,
          data[tokens.PE]?.lp,
          inputValues.riskCoverType
        );

        deforder.push(
          {
            exchange: tokens['exchange-CE'],
            variety: "REGULAR",
            validity: inputValues.validity,
            product: inputValues.product,
            orderType: inputValues.orderType,
            transactionType: typeCE,
            quantity: parseInt(inputValues.orderQty) * tokens['lotSize-CE'],
            oldquantity: parseInt(inputValues.orderQty) * tokens['lotSize-CE'],
            price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePriceCE?.price),
            triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
            exchangeToken: tokens['exchangeToken-CE'],
            disclosedQuantity: 0,
            stopLossPrice: sltpCE?.stopLossPrice ? parseFloat(sltpCE?.stopLossPrice) : null,
            targetPrice: sltpCE?.targetPrice ? parseFloat(sltpCE?.targetPrice) : null,
            trailReferencePoints: null,
            trailStepPoints: null,
            cellType: "CE",
            symbol: info.instrument,
            expiry: info.selectExpiry,
            strike: page === "strangle" || page === "custom" ? value.data.strikeCE : strike,
            lotSize: tokens['lotSize-CE'],
            instrumentToken: tokens['CE'],
            isHedge: false,
            marketProtect: inputValues.marketProtect,
            marketBuffer: inputValues.marketBuffer
          },
          {
            exchange: tokens['exchange-PE'],
            variety: "REGULAR",
            validity: inputValues.validity,
            product: inputValues.product,
            orderType: inputValues.orderType,
            transactionType: typePE,
            quantity: parseInt(inputValues.orderQty) * tokens['lotSize-PE'],
            oldquantity: parseInt(inputValues.orderQty) * tokens['lotSize-PE'],
            price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePricePE?.price),
            triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
            exchangeToken: tokens['exchangeToken-PE'],
            disclosedQuantity: 0,
            stopLossPrice: sltpPE?.stopLossPrice ? parseFloat(sltpPE?.stopLossPrice) : null,
            targetPrice: sltpPE?.targetPrice ? parseFloat(sltpPE?.targetPrice) : null,
            trailReferencePoints: null,
            trailStepPoints: null,
            cellType: "PE",
            symbol: info.instrument,
            expiry: info.selectExpiry,
            strike: page === "strangle" || page === "custom" ? value.data.strikePE : strike,
            lotSize: tokens['lotSize-PE'],
            instrumentToken: tokens['PE'],
            isHedge: false,
            marketProtect: inputValues.marketProtect,
            marketBuffer: inputValues.marketBuffer
          })
      } else {
        const calPrice = calculatePrice(
          data[tokens[cellType]]?.lp,
          inputValues.marketProtect,
          type,
          inputValues.orderType,
          inputValues.marketBuffer
        )

        const sltp = calculateSLTP(
          inputValues.stopLossPrice,
          inputValues.targetPrice,
          type,
          data[tokens[cellType]]?.lp,
          inputValues.riskCoverType
        );

        deforder.push({
          exchange: tokens['exchange-' + cellType],
          variety: "REGULAR",
          validity: page === "position" ? "DAY" : inputValues.validity,
          product: page === "position" ? value.rowData.product : inputValues.product,
          orderType: page === "position" ? instrumentConfig.entryOrderType : inputValues.orderType,
          transactionType: type,
          quantity: page === "risk" ? parseInt(value.orderQtyRisk) : parseInt(inputValues.orderQty) * tokens['lotSize-' + cellType],
          oldquantity: page === "risk" ? parseInt(value.orderQtyRisk) : parseInt(inputValues.orderQty) * tokens['lotSize-' + cellType],
          price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calPrice.price),
          triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
          exchangeToken: tokens['exchangeToken-' + cellType],
          disclosedQuantity: 0,
          stopLossPrice: sltp?.stopLossPrice ? parseFloat(sltp?.stopLossPrice) : null,
          targetPrice: sltp?.targetPrice ? parseFloat(sltp?.targetPrice) : null,
          trailReferencePoints: null,
          trailStepPoints: null,
          cellType: cellType,
          symbol: info.instrument,
          expiry: info.selectExpiry,
          strike: strike,
          lotSize: tokens['lotSize-' + cellType],
          instrumentToken: tokens[cellType],
          isHedge: false,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer
        })
      }
    }
    var basketName = "";
    if (isBoth && page === "straddle") {
      basketName = "STRADDLE-" + strike;
    } else if (isBoth && (page === "strangle" || page === "custom")) {
      basketName = "STRANGLE-" + value.data.strikeCE + "C-" + value.data.strikePE + "P";
    } else if (isBoth && page === "synFut") {
      basketName = (type === "BUY" ? "LONG-" : "SHORT-") + "SYNFUT-" + strike;
    } else {
      if (!isQT) {
        basketName = tokens['displayName-' + cellType];
      }
    }

    if (chosenBasket && typeof chosenBasket === 'object' && chosenBasket.name) {
      basketName = chosenBasket.name;
    }

    if (isSellFirst) {
      deforder.sort((a, b) => b.transactionType.localeCompare(a.transactionType))
    } else {
      deforder.sort((a, b) => a.transactionType.localeCompare(b.transactionType))
    }

    if ((hOrders && Object.keys(hOrders).length > 0) || deforder.some(o => o.isHedge)) {
      basketName = isBoth ? "Iron Fly " : cellType == "CE" ? "Call Spread " : "Put Spread ";
      for (let i = 0; i < deforder.length; i++) {

        basketName += deforder[i].strike + '/';

      }
    }

    const isGrouping = getLocalStorageObject("global-bottom-other") ? getLocalStorageObject("global-bottom-other").strategygrouping : true;
    if (!isGrouping) {
      basketName = "";
    }

    if (chosenBasket && typeof chosenBasket === 'object' && chosenBasket.name) {
      basketName = chosenBasket.name;
    }

    const perOrderRms = (transactionType) => {
      if (inputValues?.applyRmsToSellOnly && transactionType !== "SELL") {
        return {};
      }
      if (inputValues?.legRms) {
        return inputValues.legRms;
      }
    };


    const orderPram = deforder.map((item) => {
      let finalOrderType = item.orderType;
      let finalPrice = item.price;

      if (item.orderType === "Mkt protect" && (item.marketProtect === 0 || (item.marketProtect === undefined && parseFloat(inputValues.marketProtect) === 0))) {
        finalOrderType = "MARKET";
        finalPrice = null;
      } else if (item.orderType === "MARKET") {
        const mProtect = item.marketProtect || 0;
        if (parseFloat(mProtect) === 0) {
          finalOrderType = "MARKET";
          finalPrice = null;
        } else {
          finalOrderType = "LIMIT";
          const token = item.instrumentToken;
          const ltp = latestTicks[token]?.lp || 0;
          const calculated = calculatePrice(ltp, mProtect, item.transactionType);
          finalPrice = calculated.price;
        }
      } else if (item.orderType === "SL-M") {
        finalOrderType = "SL";
      } else if (item.orderType === "Mkt protect" || item.orderType === "Limit at LTP" || item.orderType === "Limit with buffer") {
        finalOrderType = "LIMIT";
      }

      return {
        "exchange": item.exchange,
        "variety": item.variety,
        "validity": item.validity,
        "product": item.product,
        "orderType": finalOrderType,
        "transactionType": item.transactionType,
        "quantity": item.quantity,
        "price": finalPrice,
        "triggerPrice": item.triggerPrice,
        "exchangeToken": item.exchangeToken,
        "disclosedQuantity": item.disclosedQuantity,
        "rms": perOrderRms(item.transactionType)
      }
    })
    let order = {
      basketName: (page === "position" || (page === "chart" && !inputValues.isBasketMode)) ? "" : page === "risk" ? tokens.basketName : page === "singleLeg" ? (chosenBasket && typeof chosenBasket === 'object' && chosenBasket.name) ? chosenBasket.name : basketName : basketName,
      basketId: (chosenBasket && typeof chosenBasket === 'object' && chosenBasket.id) ? chosenBasket.id : (tokens.basketId ? tokens.basketId : ''),
      orders: orderPram,
    };


    if (inputValues?.strategyRms && ((isQT || page == "position" || page == "chart") && !inputValues.isBasketMode)) {
      order.rms = inputValues.strategyRms;
    }

    if ((isQT || page == "position" || page == "chart") && !inputValues.isBasketMode) {
      if (isGrouping) {
        placeOrders(order);
      } else {
        const orders = order.orders;
        for (let i = 0; i < orders.length; i++) {
          order.orders = [orders[i]];
          placeOrders(order);
        }
      }



    } else {
      var prevOrder = basket;
      for (let i = 0; i < deforder.length; i++) {
        const targetBasketName = (page === "position" || (page === "chart" && !inputValues.isBasketMode)) ? "" : page === "risk" ? tokens.basketName : page === "singleLeg" ? (chosenBasket && typeof chosenBasket === 'object' && chosenBasket.name) ? chosenBasket.name : basketName : basketName;
        deforder[i].basketName = targetBasketName;

        if (deforder[i].orderType === "Limit at LTP") {
          deforder[i].price = null;
        }

        var index = prevOrder?.findIndex((item) => item.exchangeToken === deforder[i].exchangeToken && ((item.basketName || "") === (targetBasketName || "")));
        if (index === -1) {
          deforder[i].id = generateUniqueId();
          prevOrder = [...prevOrder, deforder[i]];
        } else {
          if (prevOrder[index].transactionType === deforder[i].transactionType) {
            prevOrder[index].quantity = prevOrder[index].quantity + deforder[i].quantity;
            prevOrder[index].oldquantity = prevOrder[index].quantity;
          } else {
            prevOrder[index].quantity = deforder[i].quantity;
            prevOrder[index].oldquantity = deforder[i].quantity;
            prevOrder[index].transactionType = deforder[i].transactionType;
          }
          prevOrder[index].price = deforder[i].price;
          prevOrder[index].triggerPrice = deforder[i].triggerPrice;
          prevOrder[index].stopLossPrice = deforder[i].stopLossPrice;
          prevOrder[index].targetPrice = deforder[i].targetPrice;
          prevOrder[index].marketProtect = deforder[i].marketProtect;
          prevOrder[index].marketBuffer = deforder[i].marketBuffer;
        }
      }
      const param = prevOrder.map((item) => ({
        "exchange": item.exchange,
        "variety": item.variety,
        "validity": item.validity,
        "product": item.product,
        "orderType": item.orderType === "Limit at LTP" ? "MARKET" : (["MARKET", "Mkt protect", "Limit with buffer"].includes(item.orderType) ? "LIMIT" : item.orderType),
        "transactionType": item.transactionType,
        "quantity": item.quantity,
        "price": item.price,
        "triggerPrice": item.triggerPrice,
        "exchangeToken": item.exchangeToken

      }))

      dispatch(getMarginAction(info?.broker?.id, { "orders": param })).then((data) => {
      });

      dispatch(basketAction(prevOrder));

    }

  };

  const buySellClick = async (type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket) => {
    const orderQty = parseInt(inputValues.orderQty) || 0;
    const freezeQty = parseInt(inputValues.freezeQty) || 0;
    let lotSize = 1;
    if (tokens) {
      if (isBoth) {
        lotSize = tokens['lotSize-CE'] || tokens['lotSize-PE'] || 1;
      } else if (cellType) {
        lotSize = tokens['lotSize-' + cellType] || 1;
      }
    }

    let slicingData = null;
    if (orderQty > 0 && freezeQty > 0) {
      const numOrders = Math.ceil(orderQty / freezeQty);
      if (numOrders > 5) {
        slicingData = {
          show: true,
          totalOrders: numOrders,
          maxQty: freezeQty * lotSize,
          maxLot: freezeQty,
          totalOrderQty: orderQty * lotSize,
          totalOrderLot: orderQty,
          args: [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket]
        };
      }
    }

    if (inputValues.enableOrderWindow) {
      const deforder = [];
      const tickTokenSet = new Set();

      if (isBoth) {
        if (tokens?.CE) tickTokenSet.add(tokens.CE);
        if (tokens?.PE) tickTokenSet.add(tokens.PE);
      } else if (cellType && tokens?.[cellType]) {
        tickTokenSet.add(tokens[cellType]);
      }

      let hOrders = {};
      if (hedge && hedgeVal && strikeData && Object.keys(strikeData).length > 0 && middleStrike) {
        hOrders = (hedge === "Distance") ? (strikeRef.current || {}) : (hedgeOrders || {});
        if (isBoth) {
          if (hOrders['ce']?.symbolsToStrikePrice?.CE) tickTokenSet.add(hOrders['ce'].symbolsToStrikePrice['CE']);
          if (hOrders['pe']?.symbolsToStrikePrice?.PE) tickTokenSet.add(hOrders['pe'].symbolsToStrikePrice['PE']);
        } else if (hOrders[cellType?.toLowerCase()]?.symbolsToStrikePrice?.[cellType]) {
          tickTokenSet.add(hOrders[cellType.toLowerCase()].symbolsToStrikePrice[cellType]);
        }
      }

      const data = await getTicksData(Array.from(tickTokenSet));

      if (page === 'synFut') {
        const calculatePriceCE = calculatePrice(data[tokens.CE]?.lp, inputValues.marketProtect, type === 'BUY' ? 'BUY' : 'SELL', inputValues.orderType, inputValues.marketBuffer);
        const calculatePricePE = calculatePrice(data[tokens.PE]?.lp, inputValues.marketProtect, type === 'BUY' ? 'SELL' : 'BUY', inputValues.orderType, inputValues.marketBuffer);

        deforder.push({
          displayName: tokens['displayName-CE'],
          side: type === 'BUY' ? 'BUY' : 'SELL',
          product: inputValues.product || "NRML",
          quantity: parseInt(inputValues.orderQty) || 1,
          orderType: inputValues.orderType,
          price: parseFloat(calculatePriceCE?.price),
          triggerPrice: data[tokens.CE]?.lp || 0,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer,
          token: tokens.CE,
          exchange: tokens['exchange-CE'],
          exchangeToken: tokens['exchangeToken-CE'],
          lotSize: tokens['lotSize-CE'] || 1,
          cellType: "CE",
          strike: tokens['strike-CE'] || strike,
          tickSize: tokens['tickSize-CE'] || 0.05
        }, {
          displayName: tokens['displayName-PE'],
          side: type === 'BUY' ? 'SELL' : 'BUY',
          product: inputValues.product || "NRML",
          quantity: parseInt(inputValues.orderQty) || 1,
          orderType: inputValues.orderType,
          price: parseFloat(calculatePricePE?.price),
          triggerPrice: data[tokens.PE]?.lp || 0,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer,
          token: tokens.PE,
          exchange: tokens['exchange-PE'],
          exchangeToken: tokens['exchangeToken-PE'],
          lotSize: tokens['lotSize-PE'] || 1,
          cellType: "PE",
          strike: tokens['strike-PE'] || strike,
          tickSize: tokens['tickSize-PE'] || 0.05
        });
      } else if (isBoth) {
        const calculatePriceCE = calculatePrice(data[tokens.CE]?.lp, inputValues.marketProtect, type, inputValues.orderType, inputValues.marketBuffer);
        const calculatePricePE = calculatePrice(data[tokens.PE]?.lp, inputValues.marketProtect, type, inputValues.orderType, inputValues.marketBuffer);

        deforder.push({
          displayName: tokens['displayName-CE'],
          side: type,
          product: inputValues.product || "NRML",
          quantity: parseInt(inputValues.orderQty) || 1,
          orderType: inputValues.orderType,
          price: parseFloat(calculatePriceCE?.price),
          triggerPrice: data[tokens.CE]?.lp || 0,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer,
          token: tokens.CE,
          exchange: tokens['exchange-CE'],
          exchangeToken: tokens['exchangeToken-CE'],
          lotSize: tokens['lotSize-CE'] || 1,
          cellType: "CE",
          strike: tokens['strike-CE'] || strike,
          tickSize: tokens['tickSize-CE'] || 0.05
        }, {
          displayName: tokens['displayName-PE'],
          side: type,
          product: inputValues.product || "NRML",
          quantity: parseInt(inputValues.orderQty) || 1,
          orderType: inputValues.orderType,
          price: parseFloat(calculatePricePE?.price),
          triggerPrice: data[tokens.PE]?.lp || 0,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer,
          token: tokens.PE,
          exchange: tokens['exchange-PE'],
          exchangeToken: tokens['exchangeToken-PE'],
          lotSize: tokens['lotSize-PE'] || 1,
          cellType: "PE",
          strike: tokens['strike-PE'] || strike,
          tickSize: tokens['tickSize-PE'] || 0.05
        });
      } else if (cellType && tokens?.[cellType]) {
        const calPrice = calculatePrice(data[tokens[cellType]]?.lp, inputValues.marketProtect, type, inputValues.orderType, inputValues.marketBuffer);
        deforder.push({
          displayName: tokens['displayName-' + cellType],
          side: type,
          product: inputValues.product || "NRML",
          quantity: parseInt(inputValues.orderQty) || 1,
          orderType: inputValues.orderType,
          price: parseFloat(calPrice?.price),
          triggerPrice: data[tokens[cellType]]?.lp || 0,
          marketProtect: inputValues.marketProtect,
          marketBuffer: inputValues.marketBuffer,
          token: tokens[cellType],
          exchange: tokens['exchange-' + cellType],
          exchangeToken: tokens['exchangeToken-' + cellType],
          lotSize: tokens['lotSize-' + cellType] || 1,
          cellType: cellType,
          strike: strike,
          tickSize: tokens['tickSize-' + cellType] || 0.05
        });
      }

      if (Object.keys(hOrders).length > 0) {
        const txtType = type === "BUY" ? "SELL" : "BUY";
        const hedgeLegs = isBoth ? ["ce", "pe"] : [cellType.toLowerCase()];

        hedgeLegs.forEach(leg => {
          const lType = leg.toUpperCase();
          const hType = (page === 'synFut') ? (leg === 'ce' ? txtType : type) : txtType;
          const hToken = hOrders[leg]?.symbolsToStrikePrice[lType];
          if (hToken) {
            const hLTP = data[hToken]?.lp || 0;
            const hCalPrice = calculatePrice(hLTP, inputValues.marketProtect, hType, inputValues.orderType, inputValues.marketBuffer);
            deforder.push({
              displayName: hOrders[leg].symbolsToStrikePrice['displayName-' + lType],
              side: hType,
              product: inputValues.product || "NRML",
              quantity: parseInt(inputValues.orderQty) || 1,
              orderType: inputValues.orderType,
              price: parseFloat(hCalPrice?.price),
              triggerPrice: hLTP,
              marketProtect: inputValues.marketProtect,
              marketBuffer: inputValues.marketBuffer,
              token: hToken,
              exchange: hOrders[leg].symbolsToStrikePrice['exchange-' + lType],
              exchangeToken: hOrders[leg].symbolsToStrikePrice['exchangeToken-' + lType],
              lotSize: hOrders[leg].symbolsToStrikePrice['lotSize-' + lType] || 1,
              cellType: lType,
              strike: hOrders[leg].strike,
              tickSize: hOrders[leg].symbolsToStrikePrice['tickSize-' + lType] || 0.05,
              isHedge: true
            });
          }
        });
      }

      setOrderWindowModal({
        show: true,
        orderData: { orders: deforder },
        originalArgs: [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket],
        slicingData: slicingData
      });
      return;
    }

    if (slicingData) {
      setSlicingInfo(slicingData);
      return;
    }

    processBuySell(type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket);
  };

  const pendingOrderRef = useRef(null);

  useEffect(() => {
    if (pendingOrderRef.current) {
      const { args, isBasket } = pendingOrderRef.current;
      pendingOrderRef.current = null;

      const [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket] = args;
      processBuySell(type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket);

      setinputValues(prev => ({
        ...prev,
        customPrice: 0,
        customTriggerPrice: 0,
        isBasketMode: false
      }));

      if (isBasket !== undefined) {
        setisQT(isBasket);
      }
    }
  }, [inputValues, isQT]);

  const handleOrderWindowExecute = (formData) => {
    const [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket] = orderWindowModal.originalArgs;

    const previousIsQT = isQT;
    setisQT(true);

    const mainOrder = formData.orders[0];

    const updatedInputValues = {
      ...inputValues,
      isBasketMode: false,
      product: mainOrder.product,
      orderQty: mainOrder.quantity,
      orderType: mainOrder.orderType,
      customPrice: mainOrder.price,
      customTriggerPrice: mainOrder.triggerPrice,
      marketProtect: mainOrder.marketProtect,
      marketBuffer: mainOrder.marketBuffer,
      orderWindowLegs: formData.orders,
      orderWindowTicks: orderWindowModal.ticks
    };

    pendingOrderRef.current = {
      args: [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket],
      isBasket: previousIsQT
    };

    setinputValues(updatedInputValues);
  };

  const handleOrderWindowAddToBasket = (formData) => {
    const [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket] = orderWindowModal.originalArgs;

    const previousIsQT = isQT;
    setisQT(false);

    const mainOrder = formData.orders[0];

    const updatedInputValues = {
      ...inputValues,
      isBasketMode: true,
      product: mainOrder.product,
      orderQty: mainOrder.quantity,
      orderType: mainOrder.orderType,
      customPrice: mainOrder.price,
      customTriggerPrice: mainOrder.triggerPrice,
      marketProtect: mainOrder.marketProtect,
      marketBuffer: mainOrder.marketBuffer,
      orderWindowLegs: formData.orders
    };

    pendingOrderRef.current = {
      args: [type, value, tokens, cellType, strike, isBoth, page, instrumentConfig, chosenBasket],
      isBasket: previousIsQT
    };

    setinputValues(updatedInputValues);
  };


  const placeOrders = (order) => {
    async function funplaceOrders(order) {
      await dispatch(placeOrdersAction(order, info?.broker?.id));
      if (info?.broker?.id) {
        dispatch(getFundsAction(info?.broker?.id));
      }
    }

    funplaceOrders(order);
  };

  const onResize = (e) => {

    setscrollSize(document.getElementById("basket-pannel").clientHeight - 150)
  }
  const onDragging = (e) => {
    setdragging(e);

  }

  const chartClick = (rowData, cellType, strike, page, isBoth) => {

    if (isBoth && (page === "strangle" || page === "custom")) {
      setstrikeCE(rowData.strikeCE);
      setstrikePE(rowData.strikePE);
    } if (isBoth && page === "straddle") {
      setstrikeCE(strike);
      setstrikePE(strike);
    } else {
      if (cellType === "CE") {
        setstrikeCE(strike)
      } else {
        setstrikePE(strike)
      }
    }


  }

  useLayoutEffect(() => {
    const panelGroup = document.querySelector('[data-panel-group-id="group"]');
    const resizeHandles = document.querySelectorAll(
      "[data-panel-resize-handle-id]"
    );
    const observer = new ResizeObserver(() => {
      let height = panelGroup.offsetHeight;

      resizeHandles.forEach((resizeHandle) => {
        height -= resizeHandle.offsetHeight;
      });
      setorderMinMaxSize({
        min: height > 0 ? parseInt((100 / height) * 100) : 5,
        max: 95
      })
    });
    observer.observe(panelGroup);
    resizeHandles.forEach((resizeHandle) => {
      observer.observe(resizeHandle);
    });

    return () => {
      observer.unobserve(panelGroup);
      resizeHandles.forEach((resizeHandle) => {
        observer.unobserve(resizeHandle);
      });
      observer.disconnect();
    };
  }, []);

  const handleEditBasketOrder = (row) => {
    const order = {
      displayName: row.displayName || row.tradingSymbol,
      side: row.transactionType,
      product: row.product,
      quantity: row.quantity / (row.lotSize || 1),
      orderType: ["Limit at LTP", "Limit with buffer"].includes(row.orderType) ? "LIMIT" : row.orderType,
      price: row.price,
      triggerPrice: row.triggerPrice,
      marketProtect: row.marketProtect,
      marketBuffer: row.marketBuffer,
      token: row.instrumentToken,
      exchange: row.exchange,
      exchangeToken: row.exchangeToken,
      lotSize: row.lotSize,
      cellType: row.cellType,
      strike: row.strike,
      tickSize: 0.05,
      id: row.id
    };

    setOrderWindowModal({
      show: true,
      orderData: { orders: [order] },
      originalArgs: [],
      isEditMode: true,
      editingRowId: row.id
    });
  }

  const handleOrderWindowSave = (formData) => {
    const updatedOrder = formData.orders[0];
    const editingRowId = orderWindowModal.editingRowId;

    const newBasket = basket.map(item => {
      if (item.id === editingRowId) {
        return {
          ...item,
          transactionType: updatedOrder.side,
          product: updatedOrder.product,
          quantity: updatedOrder.quantity * (item.lotSize || 1),
          orderType: updatedOrder.orderType,
          price: updatedOrder.price,
          triggerPrice: updatedOrder.triggerPrice,
          marketProtect: updatedOrder.marketProtect,
          marketBuffer: updatedOrder.marketBuffer,
        };
      }
      return item;
    });

    dispatch(basketAction(newBasket));
    checkMargin(newBasket);
  }

  const checkMargin = (basketData) => {
    const param = basketData.map((item) => ({
      "exchange": item.exchange,
      "variety": item.variety,
      "validity": item.validity,
      "product": item.product,
      "orderType": item.orderType === "Limit at LTP" ? "MARKET" : (["MARKET", "Mkt protect", "Limit with buffer"].includes(item.orderType) ? "LIMIT" : item.orderType),
      "transactionType": item.transactionType,
      "quantity": item.quantity,
      "exchangeToken": item.exchangeToken

    }))
    if (param.length > 0) {
      dispatch(getMarginAction(info?.broker?.id, { orders: param }));
    }
  }

  return (
    <div className={`main-container ${isMobile ? "" : "chartPageWrap"}`} ref={chartWrap}>
      <div className="main-div-page">
        <HeaderDropdown
          getInputValues={getInputValues}
          selectInstrument={info?.instrument}
          info={info}
          // volumeFreeze={volumeFreeze}
          //lotSize={lotSize}
          chartFilterWrap={chartFilterWrap}
        />

        <div className="das-h-page-" style={{ height: warpHeight }}>
          {/* <div className="das-h-page" > */}

          <PanelGroup autoSaveId="p-id" direction="horizontal"  >
            {windowScreen?.leftWindow &&
              <>
                <Panel id="opt-id" defaultSize={25} minSize={10} maxSize={80} collapsible={false} order={1}>


                  <div className="leftBlock-inner">
                    <Tabs>
                      <TabList>
                        <Tab onClick={() => setopActiveTab(0)}>Straddle</Tab>
                        <Tab onClick={() => setopActiveTab(1)}>Futures</Tab>
                        <Tab onClick={() => setopActiveTab(2)}>Strangle </Tab>
                        <Tab onClick={() => setopActiveTab(3)}>Custom </Tab>
                        <Tab onClick={() => setopActiveTab(4)}>Ready Made</Tab>
                      </TabList>

                      <>
                        <TabPanel>
                          <OptionActionTable
                            getATMprice={getATMprice}
                            info={info}
                            type={"basket"}
                            inputValues={inputValues}
                            getlotSize={getlotSize}
                            height={warpHeight}
                            width={optWidth}
                            globleOptionChainType={"otp"}
                            selectInstrument={info?.instrument}
                            selectExpiry={info?.selectExpiry}
                            setisQT={(e) => setisQT(e)}
                            isQT={isQT}
                            buySellClick={buySellClick}
                            source={sockSource}
                            chartClick={chartClick}
                            isRefresh={isRefresh}
                            atmVal={atmVal}
                            setatmVal={setatmVal}
                            hedge={hedge}
                            sethedge={sethedge}
                            hedgeVal={hedgeVal}
                            sethedgeVal={sethedgeVal}
                            setColumns={(item) => {
                              setColumns(item);
                              setLocalStorageObject("columnSettingsOp", "opColumns", item, localStorageObj);
                            }}
                            DropDonwcolumns={DropDonwcolumns}
                            rowHover={rowHover}
                            isSellFirst={isSellFirst}
                            setisSellFirst={setisSellFirst}
                          />
                        </TabPanel>
                        <TabPanel>
                          <Suspense fallback={<LoderCom />}>
                            <OptionActionFut
                              getATMprice={getATMprice}
                              info={info}
                              type={"futures"}
                              inputValues={inputValues}
                              getlotSize={getlotSize}
                              // height={"100%"}
                              globleOptionChainType={"otp"}
                              selectInstrument={info?.instrument}
                              selectExpiry={info?.selectExpiry}
                              setisQT={(e) => setisQT(e)}
                              isQT={isQT}
                              buySellClick={buySellClick}
                              atmVal={atmVal}
                              setatmVal={setatmVal}
                              hedge={hedge}
                              sethedge={sethedge}
                              hedgeVal={hedgeVal}
                              sethedgeVal={sethedgeVal}
                              isSellFirst={isSellFirst}
                              setisSellFirst={setisSellFirst}

                            />
                          </Suspense>
                        </TabPanel>

                        <TabPanel>
                          <Suspense fallback={<LoderCom />}>
                            <Strangle
                              atmPrice={atmPrice}
                              type={"Strangle"}
                              inputValues={inputValues}
                              getlotSize={getlotSize}
                              height={warpHeight}
                              width={optWidth}
                              globleOptionChainType={"otp"}
                              selectInstrument={info?.instrument}
                              selectExpiry={info?.selectExpiry}
                              info={info}
                              setisQT={(e) => setisQT(e)}
                              isQT={isQT}
                              buySellClick={buySellClick}
                              chartClick={chartClick}
                              atmVal={atmVal}
                              setatmVal={setatmVal}
                              hedge={hedge}
                              sethedge={sethedge}
                              hedgeVal={hedgeVal}
                              sethedgeVal={sethedgeVal}
                              rowHover={rowHover}
                              setColumns={(item) => {
                                setColumns(item);
                                setLocalStorageObject("columnSettingsOp", "opColumns", item, localStorageObj);
                              }}
                              //DropDonwcolumns={DropDonwcolumns.filter((item)=>item.accessorKey !="oiChgCE" && item.accessorKey !="oiChgPE" && item.accessorKey !="oiCE" && item.accessorKey !="oiPE")}
                              DropDonwcolumns={DropDonwcolumns}
                              isSellFirst={isSellFirst}
                              setisSellFirst={setisSellFirst}
                            />
                          </Suspense>
                        </TabPanel>
                        <TabPanel>
                          <OptionActionTable
                            getATMprice={getATMprice}
                            info={info}
                            type={"CustomOption"}
                            inputValues={inputValues}
                            getlotSize={getlotSize}
                            height={warpHeight}
                            width={optWidth}
                            globleOptionChainType={"otp"}
                            selectInstrument={info?.instrument}
                            selectExpiry={info?.selectExpiry}
                            setisQT={(e) => setisQT(e)}
                            isQT={isQT}
                            buySellClick={buySellClick}
                            chartClick={chartClick}
                            atmVal={atmVal}
                            setatmVal={setatmVal}
                            hedge={hedge}
                            sethedge={sethedge}
                            hedgeVal={hedgeVal}
                            sethedgeVal={sethedgeVal}
                            rowHover={rowHover}
                            setColumns={(item) => {
                              setColumns(item);
                              setLocalStorageObject("columnSettingsOp", "opColumns", item, localStorageObj);
                            }}
                            DropDonwcolumns={DropDonwcolumns}
                            isSellFirst={isSellFirst}
                            setisSellFirst={setisSellFirst}
                          />
                        </TabPanel>
                        <TabPanel>
                          <Suspense fallback={<LoderCom />}>
                            <ReadyMade
                              selectInstrument={info?.instrument}
                              info={info}
                              inputValues={inputValues}
                              atmVal={atmVal}
                            />
                          </Suspense>
                        </TabPanel>
                      </>
                    </Tabs>
                    <div className={isRefresh ? "refresh ref-active" : "refresh"} onClick={() => refresh()}>
                      <AutorenewIcon fontSize="small" />
                    </div>
                  </div>



                </Panel>
                <PanelResizeHandle className="drag-bar-h" onDragging={(e) => onDragging(e)} />
              </>
            }


            <Panel defaultSize={70} collapsible={false} order={2}>

              <Tabs defaultIndex={0} style={{ padding: "4px" }} className={"position-relative"} >
                <TabList>
                  <Tab onClick={() => setbasketTabs(1)}>Charts  </Tab>
                  <Tab className={isBlink && (basketTabs === 1 || windowScreen?.rightBottomWindow?.fullScreen) ? "countblink react-tabs__tab" : "react-tabs__tab"} onClick={() => setbasketTabs(2)}>
                    <div  >Basket
                      <span >({basket.length})</span>
                    </div>
                  </Tab>
                </TabList>
                {basketTabs === 1 && <QuikKeys />}
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
              <PanelGroup autoSaveId="pannel-id" direction="vertical" id="group">
                {/* {!windowScreen?.rightBottomWindow?.fullScreen && */}

                <Panel
                  id="basket-pannel"
                  collapsible={false}

                  minSize={0}
                  //max={50}
                  defaultSize={defaultSize}
                  onResize={(e) => onResize(e)}

                  style={{ overflow: clickDiv === "BasketName" ? "visible" : "inherit" }}
                >
                  <Basketindex
                    inputValues={inputValues}
                    info={info}
                    height={height}
                    windowScreen={windowScreen}
                    atmPrice={atmPrice}
                    width={width}
                    strikeCE={strikeCE}
                    strikePE={strikePE}
                    getInputValues={getInputValues}
                    buySellClick={buySellClick}
                    dragging={dragging}
                    basketTabs={basketTabs}
                    warpHeigh={warpHeight}
                    handleEditBasketOrder={handleEditBasketOrder}
                  />
                </Panel>
                {/* } */}
                <PanelResizeHandle className={!windowScreen?.rightBottomWindow?.fullScreen ? "drag-bar-v" : "drag-bar-v"} onDragging={(e) => onDragging(e)} />
                {/* <Tabs className={"position-relative"} >
                            <TabList defaultIndex={1}>
                              <Tab onClick={()=>setbasketTabs(1)}>Charts  </Tab>
                              <Tab className={(activeBasketTab === 1 || windowScreen?.rightBottomWindow?.fullScreen) ?  "countblink react-tabs__tab" : "react-tabs__tab"} onClick={()=>setbasketTabs(2)}> 
                              <div  >Basket 
                                  <span >({basket.length})</span>
                              </div>
                              </Tab>
                             <QuikKeys/>
                          </TabList>
                          </Tabs> */}
                <Panel
                  collapsible={false}
                  // minSize={10}
                  id="postition-pannel"
                  ref={panelRef}


                >
                  <Position
                    info={info}
                    height={posHeight}
                    // size={y}
                    width={posWidth}
                    inputValues={inputValues}
                    screenClick={() => {
                    }}
                    windowScreen={windowScreen}
                    buySellClick={buySellClick}
                    sockSource={sockSource}
                    warpHeigh={warpHeight}

                  />
                </Panel>
                <PanelResizeHandle />

              </PanelGroup>

            </Panel>


          </PanelGroup>
        </div>
      </div>
      <ChooseBasketModal
        show={chooseBasketState.show}
        existingBaskets={chooseBasketState.existingBaskets || []}
        defaultNewName={chooseBasketState.defaultNewName}
        showSingleLegOption={true}
        singleLegDefaultName={""}
        onClose={() => setChooseBasketState({ show: false, existingBaskets: [], defaultNewName: "", proceed: null })}
        onConfirm={({ mode, basketId, basketName }) => {
          const proceed = chooseBasketState.proceed;
          setChooseBasketState({ show: false, existingBaskets: [], defaultNewName: "", proceed: null });
          if (typeof proceed === 'function') {
            proceed({ id: basketId || '', name: basketName || '' });
          }
        }}
      />
      <SubscriptionCheckModal
        open={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        type="Terminal"
      />
      <AntModal
        title="Order Slicing - Important Information"
        open={slicingInfo.show}
        onOk={() => {
          setSlicingInfo({ ...slicingInfo, show: false });
          processBuySell(...slicingInfo.args);
        }}
        onCancel={() => setSlicingInfo({ ...slicingInfo, show: false })}
        okText="Proceed"
        cancelButtonProps={{ style: { display: 'none' } }}
        centered
      >
        <div style={{ padding: '10px 0' }}>
          <p style={{ marginBottom: '15px', fontSize: '14px' }}>
            Your order will be split into <strong>{slicingInfo.totalOrders}</strong> number of orders,
            because the Max qty per order config has been set as <strong>{slicingInfo.maxQty} Qty ({slicingInfo.maxLot} lots)</strong> and Order Qty is <strong>{slicingInfo.totalOrderQty} Qty ({slicingInfo.totalOrderLot} lots)</strong>.
          </p>
          <p style={{ marginBottom: '0', fontSize: '14px' }}>
            <strong>Please note:</strong> Broker API will have a Max Order limit of 10/second.
          </p>
        </div>
      </AntModal>
      <TerminalInfoModal
        open={showInfoModal}
        onClose={handleInfoModalClose}
      />
      <OrderWindowModal
        show={orderWindowModal.show}
        onHide={() => setOrderWindowModal({ show: false, orderData: null, originalArgs: [], isEditMode: false })}
        orderData={orderWindowModal.orderData}
        onExecute={handleOrderWindowExecute}
        onAddToBasket={handleOrderWindowAddToBasket}
        onSave={handleOrderWindowSave}
        isEditMode={orderWindowModal.isEditMode}
        lotSize={info.lotSize || 1}
        sockSource={sockSource}
        slicingData={orderWindowModal.slicingData}
      />
    </div>
  );
};

export default Dashboard;